module.exports = __webpack_public_path__ + "img/hands-holding.623242f0.svg";